import PropTypes from "prop-types";

// MUI
import { Divider, Stack, Typography } from "@mui/material";

const sxDividerAddConditions = (index = 0) => {
	if (!index) {
		return {
			height: "20px",
			marginLeft: "-8px",
		};
	}
	return null;
};

export default function TierColumnsItem(props) {
	const {
		children,
		index = 0,
		title = "Title",
		titleClassName = "tiered-title",
		sxColumns = {
			minHeight: "75px",
		},
		sxColumnItemsContainer = null,
		sxDividersContainer = {
			pt: 0.5,
		},
		sxDividers = {
			mx: 0.5,
			borderColor: "var(--strong-gray-color)",
		},
	} = props;

	const sxExtraDivider = sxDividerAddConditions(index);

	return (
		<Stack key={index} direction={"row"} sx={sxColumns}>
			<Stack justifyContent={"flex-end"} sx={sxDividersContainer}>
				<Divider className="!border-disabled" orientation={"vertical"} sx={{ ...sxDividers, ...sxExtraDivider }} />
			</Stack>
			<Stack alignItems={"center"} justifyContent={"space-between"} sx={sxColumnItemsContainer}>
				<Stack>{children}</Stack>
				<Stack alignItems={"center"}>
					<Typography variant="h5" component="div" className={titleClassName}>
						{title}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
}
TierColumnsItem.propTypes = {
	index: PropTypes.number,
	children: PropTypes.node,
	title: PropTypes.string,
	titleClassName: PropTypes.string,
	sxColumns: PropTypes.object,
	sxColumnItemsContainer: PropTypes.object,
	sxDividersContainer: PropTypes.object,
	sxDividers: PropTypes.object,
};
